import type { ReactNode } from "react";

type Props = {
  children: ReactNode;
  "aria-label"?: string;
  className?: string;
};

/**
 * Shared filter toolbar chrome (V1B). Domain pages keep chip/search logic;
 * wrap with this shell for consistent density (adoption in V1C).
 */
export function FilterToolbar({
  children,
  "aria-label": ariaLabel = "فیلترها",
  className = "",
}: Props) {
  return (
    <div
      className={`filter-toolbar ${className}`.trim()}
      role="toolbar"
      aria-label={ariaLabel}
      data-vt-filter-toolbar
    >
      {children}
    </div>
  );
}
